import { browserName, osName, isMobile } from 'mobile-device-detect'

import debounce from 'lodash/debounce';

export default {
    data: () => ({
        W: {
            w: window.innerWidth,
            h: window.innerHeight,
            ratio: window.innerWidth/window.innerHeight,
        },
        browser: {
            name: browserName.toLowerCase().replace(' ', '-'),
            os: osName.toLowerCase().replace(' ', '-'),
        },
        isMobile,
    }),
    mounted() {
        const set = () => {
            // Define window vars
            this.W = {
                w: window.innerWidth,
                h: window.innerHeight,
            }

            this.W.ratio = this.W.w/this.W.h
        }

        // Set size
        set()

        // Add Window events
        window.addEventListener('resize', this.resizeFunction = debounce(set, 100));
    },
    destroyed() {

        // Remove Window events
        window.removeEventListener('resize', this.resizeFunction);
    }
}
